export enum StageStartingPriceMethod {
  Manual = 'manual',
  Automated = 'automated',
}

export enum StageAutomaticPriceResponseStatusCode {
  Success = 200,
  NoContent = 204,
  NotFound = 404,
}
